import h from 'react-hyperscript';
import loading from './loading.svg';

export default () => {
  const style = {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
  };

  return h('div', { style }, [h('img', { src: loading, alt: 'loading' })]);
};



// WEBPACK FOOTER //
// ./src/components/Loading/index.js